import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/auth";
import { ReactNode, useEffect } from "react";
import { useModule } from "../../hooks/module";
import { EEntity, EModule } from "../table/filter/useTables";

export const ProtectedRoute = ({ children, module, entity, auth }: { children: ReactNode; auth: boolean, module?: EModule, entity?: EEntity }) => {
  const { user, expired, checkPermission } = useAuth();
  const navigate = useNavigate();
  const { changeModule } = useModule();
  const location = useLocation();
  const [ moduleChange ]  = location.pathname.split('/').filter((a) => a);
  
  useEffect(() => {
    if (moduleChange) changeModule({ module: EModule[moduleChange?.toUpperCase()] as EModule });
  },[])

  if (expired) {
    return <Navigate to="/auth/signin" />;
  }

  // Aguarda o usuário carregar antes de validar permissão
  if (auth && !user) return null;

  if (auth && !checkPermission(module, entity)) {
    return <Navigate to="/notFoundPermission" replace />;
  }

  return children;
};

export default ProtectedRoute;